import { render } from "./BlockTextNote.vue?vue&type=template&id=fe492f8c&lang=pug"
import script from "./BlockTextNote.vue?vue&type=script&lang=js"
export * from "./BlockTextNote.vue?vue&type=script&lang=js"

import "./BlockTextNote.vue?vue&type=style&index=0&id=fe492f8c&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__